import { render } from "./LoadingComponent.vue?vue&type=template&id=4aa99d96&scoped=true&ts=true"
import script from "./LoadingComponent.vue?vue&type=script&lang=ts"
export * from "./LoadingComponent.vue?vue&type=script&lang=ts"

import "./LoadingComponent.vue?vue&type=style&index=0&id=4aa99d96&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa99d96"]])

export default __exports__